import {
  AUTH_REQUEST,
  AUTH_SIGNUP,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
} from "@/store/actions/auth";
import { POPULATE_WEEK_SELECTED_NUMBER, USER_POPULATE } from "../actions/user";
import { apiCall, api_routes } from "@/utils/api";
import router from "./../../router";
import dayjs from "dayjs";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { Users } from "@/services/user-service.js";
export const STORAGE_KEY = "w-academy-pt";
const updatePlayerProfileUid = async (id, uid) => {
  const data = {
    id: id,
    uid: uid,
    action: "updatePlayerProfileUid",
  };
  await Users.find(data).catch((error) => {
    console.log(error);
  });
};
const state = {
  token: localStorage.getItem("user-token") || "",
  status: "",
  hasLoadedOnce: false,
  firebaseUser: null,
  firebaseAuthReady: false,
};

const getters = {
  isAuthenticated: (state) => !!state.token,
  authStatus: (state) => state.status,
  firebaseUser: (state) => state.firebaseUser,
  isFirebaseReady: (state) => state.firebaseAuthReady,
};

const actions = {
  [AUTH_REQUEST]: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      apiCall({ url: api_routes.user.login, data: user, method: "post" })
        .then((resp) => {
          if (resp !== "Invalid Username or Password!") {
            let token = dayjs().format("YYYY-MM-DD");
            token = `${token}/${resp[0].id}`;
            localStorage.setItem("user-token", token);
            commit(AUTH_SUCCESS, resp);
            // dispatch(USER_REQUEST);
          }

          resolve(resp);
        })
        .catch((err) => {
          commit(AUTH_ERROR, err);
          //localStorage.removeItem("user-token");
          reject(err);
        });
    });
  },
  [AUTH_SIGNUP]: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      apiCall({ url: api_routes.user.signup, data: user, method: "post" })
        .then(async (resp) => {
          // The MySQL user row is created; now attach a Firebase account.
          // Firebase Auth is keyed on the EMAIL, so a parent registering a
          // second child on the same email hits "email-already-in-use" —
          // that's expected. We sign in to the existing account (same
          // password) and stamp its uid onto the new child's row, so every
          // sibling carries the shared uid and login works for all of them.
          const auth = getAuth();
          try {
            const cred = await createUserWithEmailAndPassword(
              auth,
              user.email,
              user.password,
            );
            await updatePlayerProfileUid(user.id, cred.user.uid);
          } catch (error) {
            if (error.code === "auth/email-already-in-use") {
              try {
                const cred = await signInWithEmailAndPassword(
                  auth,
                  user.email,
                  user.password,
                );
                await updatePlayerProfileUid(user.id, cred.user.uid);
              } catch (signInError) {
                // Same email, different password: the parent would be locked
                // out at login. Surface it instead of silently continuing.
                reject(
                  new Error(
                    "This email is already registered for another child, but the password is different. Please use the same password you created for your first child.",
                  ),
                );
                return;
              }
            } else {
              console.error("Error during signup:", error.code, error.message);
            }
          }
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise((resolve) => {
      commit(AUTH_LOGOUT);
      localStorage.removeItem("user-token");
      localStorage.removeItem("the_w_selectedClientId");
      localStorage.removeItem("weekNumber");
      localStorage.removeItem("calendarDate");
      localStorage.removeItem("mondaySunDates");
      localStorage.removeItem("coachesUsersData");
      localStorage.removeItem("currentPlayingSeason");
      localStorage.removeItem("currentPlayingseasonStartDate");
      localStorage.removeItem("currentPlayingseasonEndDate");
      localStorage.removeItem("the_w_clubId");
      localStorage.removeItem("userHasMoreThanOneAccount");
      commit(POPULATE_WEEK_SELECTED_NUMBER, null);
      commit(USER_POPULATE, null);
      router.push("/login");
      resolve();
    });
  },
};

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = "loading";
  },
  [AUTH_SUCCESS]: (state) => {
    state.status = "success";
    state.token = "test-token";
    state.hasLoadedOnce = true;
    Event.$emit("user-authenticated");
  },
  [AUTH_ERROR]: (state) => {
    state.status = "error";
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = "";
    state.firebaseUser = null;
    state.firebaseAuthReady = false;
  },
  [POPULATE_WEEK_SELECTED_NUMBER](state, selectedWeek) {
    state.selectedWeek = selectedWeek;
  },
  [USER_POPULATE]: (state, resp) => {
    state.profile = resp || {};
  },
  setFirebaseUser: (state, user) => {
    state.firebaseUser = user;
    state.firebaseAuthReady = true;
  },
  setFirebaseAuthReady: (state, ready) => {
    state.firebaseAuthReady = ready;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
